export default "__VITE_ASSET__ab302b25__"